
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_9756_80812)"}},[_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"url(#paint0_linear_9756_80812)"}}),_c('path',{attrs:{"d":"M8.915 6.27c.283-.115.554-.216.8-.292A13.016 13.016 0 0111.72 7.52c.77-.866 1.105-1.675.808-2.19-.551-.955-3.062-.538-5.61.93.041-.3.09-.586.147-.837.28-.147.563-.288.847-.414.225-.1.448-.19.671-.275a11.5 11.5 0 01.82-.276c-.366-1.098-.899-1.794-1.493-1.794-1.104 0-1.998 2.383-2 5.325a9.87 9.87 0 01-.652-.548c.013-.316.032-.63.065-.94.026-.244.06-.483.098-.719.047-.292.104-.575.17-.847-1.134-.233-2.003-.12-2.3.395-.552.956 1.064 2.922 3.611 4.395a9.842 9.842 0 01-.8.29c-.267-.169-.53-.343-.782-.526a13.04 13.04 0 01-1.222-1.016c-.768.866-1.105 1.676-.807 2.19.551.956 3.062.54 5.61-.929-.041.3-.09.586-.148.837-.28.147-.562.288-.846.414-.225.1-.448.19-.671.275-.277.104-.551.197-.82.276.366 1.099.899 1.794 1.493 1.794 1.103 0 1.998-2.383 2-5.324.24.187.463.371.652.547-.013.316-.032.631-.065.94a13.239 13.239 0 01-.269 1.567c1.135.232 2.003.119 2.3-.396.553-.956-1.064-2.922-3.61-4.394zM7.908 8.663a.667.667 0 110-1.334.667.667 0 010 1.334z","fill":"#fff"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_9756_80812","x1":"3.2","y1":"2","x2":"12.4","y2":"14.8","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#0073FF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0032E8"}})]),_c('clipPath',{attrs:{"id":"clip0_9756_80812"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    